import { useIntl } from 'react-intl';
import { Link as RouterLink } from 'react-router-dom';
import { getIDFromUrl, Url } from '@rossum/api-client';
import { Link, Stack, Typography } from '@rossum/ui/material';
import { globals, RowModel } from '../rows/helpers';
import { CellIcons } from './CellIcons';
import { CellValueSkeleton } from './CellValueSkeleton';
import { resolveMessagesByPriority } from './utils';

const DocumentCell = ({
  value,
  globals: { messages, automationBlockers },
  annotationUrl,
}: {
  annotationUrl: Url;
  value: string | undefined;
  globals: RowModel[typeof globals];
}) => {
  const resolvedMessages = resolveMessagesByPriority(messages ?? []) ?? [];
  const resolvedAutomationBlockers = automationBlockers ?? [];
  const intl = useIntl();

  return value === undefined && annotationUrl !== 'preview' ? (
    <CellValueSkeleton />
  ) : (
    <Stack
      direction="row"
      spacing={1}
      width="100%"
      height="100%"
      alignContent="center"
    >
      {resolvedMessages.length > 0 || resolvedAutomationBlockers.length > 0 ? (
        <Stack alignSelf="center">
          <CellIcons
            type={null}
            messages={resolvedMessages}
            automationBlockers={resolvedAutomationBlockers}
          />
        </Stack>
      ) : null}

      {annotationUrl === 'preview' ? (
        <Typography
          color="text.disabled"
          variant="inherit"
          alignContent="center"
        >
          {intl.formatMessage({ id: 'features.formulas.previewRow' })}
        </Typography>
      ) : (
        <Link
          component={RouterLink}
          to={`/document/${getIDFromUrl(annotationUrl)}`}
          target="_blank"
          sx={{
            color: 'inherit',
            textDecoration: 'none',
            textOverflow: 'ellipsis',
            maxWidth: '100%',
            overflow: 'hidden',
            alignSelf: 'center',
            '&:hover': {
              color: 'inherit',
            },
          }}
        >
          {value}
        </Link>
      )}
    </Stack>
  );
};

export { DocumentCell };
